<div [ngClass]="{'about-component':true, 'en':(currentLanguage |async) ==='en'}">
  <p-card>
    <div class="about-container">
      <img class="background-image" src="assets/odot-heb.svg" alt="">
      <div class="section">
        <h2 class="title"> {{'iaa.authentication.iaaTitle' | translate}}</h2>
      </div>
      <div class="section">
        <div class="white-space" [innerHTML]="(
          ('iaa.authentication.iaaDescriptionShort' | translate| brToNewLine) + 
          ('iaa.authentication.iaaDescriptionRest' | translate | brToNewLine) +' ' +
          ('iaa.authentication.iaaEmailsForAbout' | translate: { yoavEmail: yoavEmail, mokediaaEmail: mokediaaEmail }) | brToNewLine)">
      </div>
      </div>
    </div>
  </p-card>
</div>